import { Expose, Type } from 'class-transformer';
import { SpaceFloorDto } from './space-floor.dto';
import { SpaceBuildingDto } from './space-building.dto';

export class GetSpaceResponseDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'name' })
  name: string;
  @Expose({ name: 'code' })
  code: string;
  @Expose({ name: 'size' })
  size: number;
  @Expose({ name: 'is_port' })
  isPort: boolean;
  @Expose({ name: 'type' })
  type: string;
  @Expose({ name: 'floor_id' })
  floorId: number;
  @Expose({ name: 'floor' })
  @Type(() => SpaceFloorDto)
  floor: SpaceFloorDto;
  @Expose({ name: 'building' })
  @Type(() => SpaceBuildingDto)
  building: SpaceBuildingDto;
  @Expose({ name: 'company_id' })
  companyId: number;
}
